export default "__VITE_ASSET__48K6i9n9__"